const isEnabledFlag = (value) => {
  if (value == null || value === '') {
    return true;
  }

  return String(value).trim().toLowerCase() === 'true';
};

export const NOTIFICATION_FEATURE_FLAGS = {
  fcm: isEnabledFlag(process.env.REACT_APP_ENABLE_FCM),
  socketIo: isEnabledFlag(process.env.REACT_APP_ENABLE_SOCKET_IO),
};
